import { render } from "./UndertakingAnalysis.vue?vue&type=template&id=6bbf9644"
import script from "./UndertakingAnalysis.vue?vue&type=script&lang=js"
export * from "./UndertakingAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__